import {Modal as BootstrapModal, ModalBody, ModalHeader} from 'reactstrap'
import {withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'

import Modal from '../../../../shared/components//Modals/Modal.jsx'

class SimpleModal extends Modal {
  static propTypes = {
    body: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    header: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    confirmText: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }

  confirm = () => {
    this.props.closeModal()
  }

  render() {
    const modalProps = {}
    const {body, header, confirmText} = this.props

    if (!this.state.loading) {
      modalProps.toggle = this.close
    }

    return (
      <BootstrapModal toggle={this.cancel} isOpen={this.props.isOpen}>
        <ModalHeader toggle={this.cancel}>{header}</ModalHeader>
        <ModalBody>
          {body}
          <div className="d-flex justify-content-around">
            <button onClick={this.confirm} type="button" className="btn btn-secondary">{confirmText ? confirmText : 'Fermer'}</button>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}

export default withRouter(SimpleModal)
